export const rbacCatalogUrl = () => "/api/v1/rbac/catalog";
export const rbacRulesUrl = () => "/api/v1/rbac/rules";
export const rbacRuleByIdUrl = (id: string) => `/api/v1/rbac/rules/${id}`;
export const rbacMePermissionsUrl = () => "/api/v1/rbac/me/permissions";
export const getSodPrecheckUrl = () => "/admin/roles/check-sod";
